"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgEyeOffFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M16 12a4 4 0 00-4 4z" }),
        React.createElement("path", { d: "M5.56 22.43l4.7-4.69A5.86 5.86 0 0110 16a6 6 0 016-6 5.91 5.91 0 011.74.26l3.94-3.94A13.66 13.66 0 0016 5C10.78 5 5.33 8.49 2.1 13.88L.83 16l1.27 2.12a20.15 20.15 0 003.46 4.31zM29.89 13.88A20 20 0 0025.81 9L30 4.82V2L2 30h2.82l4.72-4.71A14 14 0 0016 27c5.21 0 10.67-3.48 13.89-8.88L31.16 16zM22 16a6 6 0 01-6 6 6.07 6.07 0 01-2.59-.59L15 19.85a3.88 3.88 0 001 .15 4 4 0 004-4 3.88 3.88 0 00-.15-1l1.55-1.55A5.86 5.86 0 0122 16z" })));
}
exports.default = SvgEyeOffFilled;
//# sourceMappingURL=EyeOffFilled.js.map